import {
  DataGrid,
  DataGridActions,
  DataGridColumns,
  DataGridSections,
  DataGridSelectedActions,
} from '@components/DataGrid/DataGrid'
import { DataGridPerson } from '@components/DataGrid/DataGridPerson'
import ExampleUser from '@assets/exampleUser.png'
import { useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import { Anchor, Button, Text } from '@mantine/core'
import { DataGridList } from '@components/DataGrid/DataGridList'

export const AccountRepresentatives = () => {
  const navigate = useNavigate()

  const handleNavigate = () =>
    navigate(`../${RoutePaths.RECORD}/123/${RoutePaths.RECORD_HOME}`, {
      state: {
        history: [
          {
            title: 'Community',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
          {
            title: 'Members',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
        ],
      },
    })

  const data = Array(30)
    .fill(0)
    .map((_, i) => {
      return {
        id: `account-reps-${i}`,
        name: (
          <DataGridPerson
            name="Alfredo Carrillo"
            image={ExampleUser}
            status="online"
            onClick={handleNavigate}
          />
        ),
        email: (
          <Anchor c="dark" href="mailto:alfredo@carrillo.com">
            alfredo@carrillo.com
          </Anchor>
        ),
        direct: (
          <Anchor c="dark" href="tel:+1 (212) 555-1212">
            +1 (212) 555-1212
          </Anchor>
        ),
        locations: (
          <DataGridList
            title="Locations"
            data={['Some', 'Another', 'Another']}
          />
        ),
      }
    })

  const columns: DataGridColumns[] = [
    {
      label: 'Name',
      prop: 'name',
      defaultSort: true,
      pinned: true,
    },
    {
      label: 'Email',
      prop: 'email',
    },
    {
      label: 'Direct',
      prop: 'direct',
    },
    {
      label: 'Locations',
      prop: 'locations',
    },
  ]

  const sections: DataGridSections[] = [
    {
      label: 'All Representatives',
      href: '#',
      default: true,
    },
  ]

  const actions: DataGridActions[] = [
    {
      label: 'Remove',
      onClick: (item: any) => console.log('Action'),
    },
  ]

  const selectedActions: DataGridSelectedActions[] = [
    {
      label: 'Remove all',
      onClick: (items: any) => console.log('Selected Actions: Edit'),
    },
  ]

  return (
    <>
      <Text size="md" p="md">
        Representatives must have a controlling stake in, or be authorized to
        bind the organization and manage its account. A representative is a
        special kind of Administrator who can perform all actions, including
        managing subscriptions to BlueCard services and add-ons,
        representatives, permissions sets, all locations, teams, and records,
        and closing the account.
      </Text>
      <DataGrid
        data={data}
        columns={columns}
        sections={sections}
        actions={actions}
        results={data.length}
        buttons={<Button>Add</Button>}
        selectedActions={selectedActions}
        page={1}
      />
    </>
  )
}
